export default __webpack_public_path__ + "static/media/img4.a82d1d58.png";